import { createProductCardErrorText } from '../createProductCardErrorText';

const createProductCardPanic =
  <TContent extends Record<string, unknown>>(content: TContent) =>
  (error: string) => ({
    ...content,
    errors: [createProductCardErrorText(error)],
    sections: [],
    dbs: {},
    productIds: [],
  });

export default createProductCardPanic;
